import { memo, type PropsWithChildren } from "react";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import { DOMAIN } from "consts/general";
import { useCloseLoadingBackdropOverlay } from "ui/layouts/LoadingBackdropOverlay";
import type { StepProps } from "../types";
import useOnboardingGettingStarted from "./useOnboardingGettingStarted";

const OnboardingGettingStarted = ({ slots, children }: PropsWithChildren<StepProps>) => {
    useCloseLoadingBackdropOverlay();

    const {
        isLoading,
        onComplete
    } = useOnboardingGettingStarted();

    return (
        <Card>
            <CardContent
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: 1
                }}
            >
                <Box>
                    <Typography
                        variant='h4'
                        sx={{
                            fontWeight: 600
                        }}
                    >
                        Get Started with Macropay
                    </Typography>
                    <Typography
                        variant='body1'
                        sx={{
                            color: 'text.secondary',
                            mt: 2
                        }}
                    >
                        Complete your onboarding to activate your account and start processing
                    </Typography>
                    <Box
                        component='a'
                        href={`//${DOMAIN}/terms-and-conditions`}
                        sx={{
                            textDecoration: 'none',
                            display: 'inline-block',
                            color: 'primary.main',
                            mt: 3
                        }}
                    >
                        Why we ask for this information?
                    </Box>
                    <LoadingButton
                        variant='contained'
                        color='secondary'
                        sx={{
                            mt: 3
                        }}
                        loading={isLoading}
                        onClick={onComplete}
                    >
                        Start Onboarding
                    </LoadingButton>
                    <Box
                        sx={{
                            mt: 3,
                            fontWeight: 600
                        }}
                    >
                        {slots?.stats}
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'grid',
                        alignSelf: 'flex-start',
                        gap: 1,
                        position: 'relative',
                        '::before': {
                            content: '""',
                            position: 'absolute',
                            inset: 0,
                            width: '100%',
                            height: '100%',
                            bgcolor: 'transparent'
                        }
                    }}
                >
                    {children}
                </Box>
            </CardContent>
        </Card>
    );
};

export default memo(OnboardingGettingStarted);
